// extracted by mini-css-extract-plugin
export var copyable = "_q-1";
export var explainable = "_q-0";
export var negative = "_q-2";
export var positive = "_q-3";